var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0ab9994b95c256de9ca0839a9632cc73a65b2145"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fontvisual"]={id:"0ab9994b95c256de9ca0839a9632cc73a65b2145"};
      